<div class="form-container">
  <div class="header-container">
    <div class="font-semibold text-xl" >
      {{ countryId == 2 ? 'Upload Mulkiya' : 'Upload RTO' }}
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
    <button pButton class="custom-upload-button btn-primary " type="submit">
      Upload and Next
      <i class="pi pi-arrow-right arrow-icon" style="margin-left: 8px;"></i>
    </button>
  </form>
</div>